export const getProductsFile = () => ({
  type: "@saga/GET_PRODUCTS_FILE",
});
